import type { Team } from "@repo/shared/types";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useT } from "@/lib/i18n/use-t";
import { TeamDialog } from "./team-dialog";
import { TeamsTable } from "./teams-table";
import { T } from "./teams-wrapper.i18n";

export function TeamsWrapper({ teams }: { teams: Team[] }) {
  const t = useT(T);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editing, setEditing] = useState<Team | null>(null);

  const handleCreate = () => {
    setEditing(null);
    setDialogOpen(true);
  };

  const handleEdit = (team: Team) => {
    setEditing(team);
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
    setEditing(null);
  };

  return (
    <>
      <div className="flex justify-end mb-4">
        <Button onClick={handleCreate}>{t.addTeam}</Button>
      </div>

      <TeamsTable teams={teams} onEdit={handleEdit} />

      <TeamDialog open={dialogOpen} team={editing} onClose={handleClose} />
    </>
  );
}
